@if (message()?.id) {
<div class="card">
  <div class="card__title">Message from LakeHouse <a class="card__title-link" routerLink="/messages">View All Messages</a></div>
  <div class="card__content">
    <div class="notif notif--messages">
      <div class="notif-item">
        <p class="notif-item__date">{{ message()?.dateSent | date:'MMM dd, yyyy'}}</p>
        <div class="notif-item__text" [innerHTML]="message()?.content"></div>
      </div>
    </div>
  </div>
</div>
}
